<template>
  <div>
    <list
      row-key="PurchaseArrivalId"
      ref="list"
      unit="应付总账"
      :page="page"
      :query-params="params"
      :show-checkbox="false"
      :show-query="showQuery"
      :delete-func="api.delete"
      :get-data-func="api.DetailsList"
      show-summary  
      :summary-method="getSummaries"
      :pageSizes="[10, 20, 30, 40, 100, 1000]"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="单据编号">
          <el-input size="mini" clearable v-model="params.OrderNo" placeholder="请输入单据编号" />
        </el-form-item>
        <el-form-item label="商品名称">
         <el-input size="mini" clearable v-model="params.GoodsName" placeholder="请输入商品名称" />
        </el-form-item>
 
        <template>
          <el-form-item label="单据日期">
            <el-date-picker
              v-model="params.DocDateStart"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择开始时间"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="截止日期">
            <el-date-picker
              v-model="params.DocDateEnd"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择结束时间"
            ></el-date-picker>
          </el-form-item>
        <el-form-item label="所属机构">
              <el-select size="mini" v-model="params.DpId" placeholder="请选择机构" clearable>
         
                  <el-option v-for="(item,key) in DpList" :key="key" :label="item.DpName" :value="item.DpId"></el-option>
           
              </el-select>
            </el-form-item>
        </template>

      </template>
      <template slot="table">
        <el-table-column prop="DpName" label="所属机构" min-width="100px" />
      <el-table-column prop="OrderNo" label="单据编号"/>
       <el-table-column prop="DocDate" label="单据日期" min-width="100px">
         <template slot-scope="{row}">{{$commonJs.toDateString(row.DocDate)}}</template>
      </el-table-column>
      <el-table-column prop="CustomerName" label="往来单位" />
      <el-table-column prop="GoodsCode" label="商品编码" min-width="90px"/>
      <el-table-column prop="GoodsName" label="商品名称"/>
      <el-table-column prop="Model" label="规格型号" />
      <el-table-column prop="UnitName" label="单位" />
      <el-table-column prop="Quantity" label="数量"/>
      <el-table-column prop="Price" label="单价">
          <template slot-scope="{ row }">
            {{$commonJs.toThousands(row.Price)}}
          </template>
      </el-table-column>
      <el-table-column prop="Amount" label="金额">
          <template slot-scope="{ row }">
            {{$commonJs.toThousands(row.Amount)}}
          </template>
      </el-table-column>
      <el-table-column prop="Remark" label="备注"/>      
      <el-table-column prop="ClassName" label="商品类别"/>
      <!--<el-table-column prop="ExistQuantity" label="现存量" />
      <el-table-column prop="AvailableQuantity" label="可用量 " />-->
      <el-table-column prop="Offer" label="报价">
          <template slot-scope="{ row }">
            {{$commonJs.toThousands(row.Offer)}}
          </template>
      </el-table-column>
      <el-table-column prop="Discount" label="折扣%"/>     
      <el-table-column prop="TaxRate" label="税率/%"/>
      <el-table-column prop="TaxAmount" label="税额">
          <template slot-scope="{ row }">
            {{$commonJs.toThousands(row.TaxAmount)}}
          </template>
      </el-table-column>
     
      <el-table-column prop="" label="参与活动"/>
      <el-table-column prop="ReferenceCost" label="预估成本单价" min-width="110px">
          <template slot-scope="{ row }">
            {{$commonJs.toThousands(row.ReferenceCost)}}
          </template>
      </el-table-column>
      <el-table-column prop="GrossProfit" label="毛利">
          <template slot-scope="{ row }">
            {{$commonJs.toThousands(row.GrossProfit)}}
          </template>
      </el-table-column>
      <!-- slot[column] -->
      <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/sale/sales").default,
      dpApi: require("@/api/ent/dp").default,
      params: {
         GoodsName:"",
         DocNo:"",
         DocDateStart:'',
         DocDateEnd:'',
        DpId:null//所属门店
      },
      isMB: this.$store.state.isMB,
      DpList:[]
    };
  },
  created(){
    this.dpApi.parentList({DpType:1}).then(res => {
       
       this.DpList = res.Data;
     })
  },
  computed: {
    date() {
      return [this.params.MonthStart, this.params.MonthEnd];
    },
    sDate() {
      return this.$dayjs().endOf("month").format("YYYY-MM-DD");
    },
    eDate() {
      return this.$dayjs()
        .subtract(3, "month")
        .startOf("month")
        .format("YYYY-MM-DD");
    },
  },
  methods: {
    onExport() {
      this.api.export(this.params);
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (index === 8 || index === 10) {
          const values = data.map((item) => Number(item[column.property]));
          if (!values.every((value) => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return Math.floor( (prev + curr)*100 )/100;
              } else {
                return Math.floor(prev*100)/100;
              }
            }, 0);
            sums[index] = sums[index];
          }
          return;
        }
      });
      return sums;
    },
    setTradeunit(data) {
      this.params.TradeUnitId = data.CustomerId;
      this.params.TradeUnitName = data.CustomerFullName;
    },
    dateChange(val) {
      this.params.DocDateStart = val.Start;
      this.params.DocDateEnd = val.End;
    },
    monthChange(val) {
      this.params.MonthStart = val.Start;
      this.params.MonthEnd = val.End;
    },
    onClick(row) {
      
      this.$refs.listDialog.open().then((that) => {
        var params = {
          TradeUnitId: row.TradeUnitId,
          TradeUnitName: row.TradeUnitName,
          DocDateStart: this.params.DocDateStart,
          DocDateEnd: this.params.DocDateEnd,
        };
        that.query(params);
      });
    },
    cycleChange(t) {
      var today = this.$commonJs.getToday();
      var start = "";
      var end = "";
      switch (t) {
        case "今天":
          start = today;
          end = today;
          break;
        case "昨天":
          start = this.$dayjs().subtract(1, "day").format("YYYY-MM-DD");
          end = start;
          break;
        case "近3天":
          start = this.$dayjs().subtract(2, "day").format("YYYY-MM-DD");
          end = today;
          break;
        case "近7天":
          start = this.$dayjs().subtract(6, "day").format("YYYY-MM-DD");
          end = today;
          break;
        case "近14天":
          start = this.$dayjs().subtract(13, "day").format("YYYY-MM-DD");
          end = today;
          break;
        case "本周":
          start = this.$dayjs().startOf("week").format("YYYY-MM-DD");
          end = today;
          break;
        case "上周":
          var week = this.$dayjs().subtract(1, "week");
          start = week.startOf("week").format("YYYY-MM-DD");
          end = week.endOf("week").format("YYYY-MM-DD");
          break;
        case "本月":
          start = this.$dayjs().startOf("month").format("YYYY-MM-DD");
          end = today;
          break;
        case "上月":
          var month = this.$dayjs().subtract(1, "month");
          start = month.startOf("month").format("YYYY-MM-DD");
          end = month.endOf("month").format("YYYY-MM-DD");
          break;
        case "本季":
          start = this.$dayjs().startOf("quarter").format("YYYY-MM-DD");
          end = today;
          break;
        case "上季":
          var quarter = this.$dayjs().subtract(1, "quarter");
          start = quarter.startOf("quarter").format("YYYY-MM-DD");
          end = quarter.endOf("quarter").format("YYYY-MM-DD");
          break;
        case "本年":
          start = this.$dayjs().startOf("year").format("YYYY-MM-DD");
          end = today;
          break;
        case "上年":
          var year = this.$dayjs().subtract(1, "year");
          start = year.startOf("year").format("YYYY-MM-DD");
          end = year.endOf("year").format("YYYY-MM-DD");
          break;
      }
      this.params.DocDateStart = start;
      this.params.DocDateEnd = end;
      this.query();
    },
  },
};
</script>